import Tooltip from 'rc-tooltip';
import cx from 'classnames';
import {useMemo} from 'react';
import {useSelector} from 'react-redux';
import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';
import {useMatchQuery} from '~library/hooks/useMatchQuery';
import {getLoggedUserId} from '~/common/fabric/User/reducers/user';
import {CloseLineIcon} from '~library/svg/CloseLineIcon';
import {DuplicateIcon} from '~library/svg/DuplicateIcon';
import {mediumAndUpQuery} from '~libSass/base/_exports.sass';
import {ArrowIcon} from '~library/svg/ArrowIcon';
import 'rc-tooltip/assets/bootstrap.css';

import './SlotToolBar.sass';

export const SlotToolBar = ({
  className,
  length,
  index,
  onDeleteItem,
  onDuplicateItem,
  onMoveItemUp,
  onMoveItemDown,
  canMoveUp,
  canMoveDown,
}) => {
  const isLoggedIn = useSelector(getLoggedUserId);
  const {matches: isDesktop} = useMatchQuery(`(${mediumAndUpQuery})`);

  const trigger = useMemo(() => (isDesktop ? ['hover', 'click'] : []), [isDesktop]);

  const DeleteButton = useMemo(
    () => (
      <Tooltip
        overlayClassName="slot-toolbar__tooltip"
        placement="left"
        overlay={
          <Typography
            as="span"
            variant="paragraph3"
            data-qa-id="duplicate-overlay"
            color="charcoal"
          >
            Delete
          </Typography>
        }
        trigger={trigger}
      >
        <Button
          variant="unstyled-button"
          className="slot-toolbar__button"
          data-qa-id={`slot-toolbar-delete-${index}`}
          onClick={() => onDeleteItem(index)}
          disabled={!isLoggedIn}
        >
          <CloseLineIcon />
        </Button>
      </Tooltip>
    ),
    [isDesktop, trigger, index, onDeleteItem, isLoggedIn]
  );

  return (
    <div className={cx('slot-toolbar', className)}>
      {length > 1 && (
        <>
          {isDesktop ? DeleteButton : null}
          {canMoveUp && (
            <Tooltip
              overlayClassName="slot-toolbar__tooltip"
              placement="left"
              overlay={
                <Typography
                  as="span"
                  variant="paragraph3"
                  data-qa-id="duplicate-overlay"
                  color="charcoal"
                >
                  Move slots up
                </Typography>
              }
              trigger={['hover', 'click']}
            >
              <Button
                variant="unstyled-button"
                className="slot-toolbar__button"
                data-qa-id={`slot-toolbar-delete-${index}`}
                onClick={() => onMoveItemUp(index)}
                disabled={!isLoggedIn}
              >
                <ArrowIcon direction="up" ratio={0.5} />
              </Button>
            </Tooltip>
          )}
          {canMoveDown && (
            <Tooltip
              overlayClassName="slot-toolbar__tooltip"
              placement="left"
              overlay={
                <Typography
                  as="span"
                  variant="paragraph3"
                  data-qa-id="duplicate-overlay"
                  color="charcoal"
                >
                  Move slots down
                </Typography>
              }
              trigger={['hover', 'click']}
            >
              <Button
                variant="unstyled-button"
                className="slot-toolbar__button"
                data-qa-id={`slot-toolbar-delete-${index}`}
                onClick={() => onMoveItemDown(index)}
                disabled={!isLoggedIn}
              >
                <ArrowIcon direction="down" ratio={0.5} />
              </Button>
            </Tooltip>
          )}
          {isDesktop ? null : DeleteButton}
        </>
      )}
      <Tooltip
        overlayClassName="slot-toolbar__tooltip"
        placement="left"
        overlay={
          <Typography
            as="span"
            variant="paragraph3"
            data-qa-id="duplicate-overlay"
            color="charcoal"
          >
            Duplicate
          </Typography>
        }
        trigger={trigger}
      >
        <Button
          variant="unstyled-button"
          className="slot-toolbar__button"
          data-qa-id={`slot-toolbar-duplicate-${index}`}
          onClick={() => onDuplicateItem(index)}
          disabled={!isLoggedIn}
        >
          <DuplicateIcon />
        </Button>
      </Tooltip>
    </div>
  );
};
